/*
	Search Popup
*/

var variables = window.nffleet_variables;
var functions = window.nffleet_functions;
var events = window.nffleet_events;

var contactBtns = document.querySelectorAll("[href='#contact']");

for (var i = 0; i < contactBtns.length; i++) {
    contactBtns[i].addEventListener("click", createContactForm);
}

function createContactForm() {
    this.blur();

    var formContent;

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState === 4) {
            if (this.readyState === 4 && this.status === 200) {
                var response = JSON.parse(this.responseText);
                formContent = response;
            }
        }
    };

    xhttp.open("GET", "/umbraco/api/form/getcontactform", false);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();

    if (!formContent) {
        return;
    }

    var contactWrapper = functions.getPopUpWrapperWithBackground();

    var contactContainer = document.createElement(variables.divTag);
    contactContainer.classList.add("mfp-container");
    contactContainer.classList.add("mfp-s-ready");
    contactContainer.classList.add("mfp-inline-holder");
    contactWrapper.appendChild(contactContainer);

    var contactContent = document.createElement(variables.divTag);
    contactContent.classList.add("mfp-content");
    contactContainer.appendChild(contactContent);

    var contactContentContainer = document.createElement(variables.divTag);
    contactContentContainer.id = "contact";
    contactContentContainer.classList.add("max-width-3");
    contactContentContainer.classList.add("centered");
    contactContent.appendChild(contactContentContainer);

    var contactFormWrapper = document.createElement(variables.divTag);
    contactFormWrapper.classList.add("contact-form-wrapper");
    contactContentContainer.appendChild(contactFormWrapper);

    var contactForm = window.nffleet_form(formContent);
    contactFormWrapper.appendChild(contactForm);

    var closeButton = document.createElement(variables.buttonTag);
    closeButton.title = "Close (ESC)";
    closeButton.type = "button";
    closeButton.classList.add("mfp-close");
    closeButton.classList.add("mfp-close-contact");
    closeButton.innerHTML = "×";
    contactContentContainer.appendChild(closeButton);

    contactForm.addEventListener(variables.destroyListener, function () {
        destroyPopup();
    });

    contactForm.addEventListener(variables.formSubmittedListener, function () {
        closeButton.style.display = "none";
    });

    contactWrapper.addEventListener(variables.clickListener, function (event) {
        if (event.target !== contactContent && !contactContent.contains(event.target)) {
            destroyPopup();
        }
    });

    closeButton.addEventListener(variables.clickListener, destroyPopup);

    function destroyPopup() {
        contactWrapper.dispatchEvent(events.destroy());
    }
}

if (window.location.hash === "#contact") {
    createContactForm();
}